import type { Show } from '../types/show';

export const shows: Show[] = [
  { rank: 1, title: 'Breaking Bad', years: '2008–2013' },
  { rank: 2, title: 'The Wire', years: '2002–2008' },
  { rank: 3, title: 'Mad Men', years: '2007–2015' },
  { rank: 4, title: 'Succession', years: '2018–2023' },
  { rank: 5, title: 'Fleabag', years: '2016–2019' },
  { rank: 6, title: 'Game of Thrones', years: '2011–2019' },
  { rank: 7, title: 'Veep', years: '2012–2019' },
  { rank: 8, title: '30 Rock', years: '2006–2013' },
  { rank: 9, title: 'Curb Your Enthusiasm', years: '2000–2024' },
  { rank: 10, title: 'Atlanta', years: '2016–2022' },
  { rank: 11, title: 'The Office (U.S.)', years: '2005–2013' },
  { rank: 12, title: 'Arrested Development', years: '2003–2019' },
  { rank: 13, title: 'Girls', years: '2012–2017' },
  { rank: 14, title: 'Friday Night Lights', years: '2006–2011' },
  { rank: 15, title: 'Six Feet Under', years: '2001–2005' },
  { rank: 16, title: 'The Office (U.K.)', years: '2001–2003' },
  { rank: 17, title: 'The Americans', years: '2013–2018' },
  { rank: 18, title: 'I May Destroy You', years: '2020' },
  { rank: 19, title: 'Chernobyl', years: '2019' },
  { rank: 20, title: 'The Crown', years: '2016–2023' },
  { rank: 21, title: 'The White Lotus', years: '2021–present' },
  { rank: 22, title: 'Lost', years: '2004–2010' },
  { rank: 23, title: 'The Comeback', years: '2005–2026' },
  { rank: 24, title: 'Deadwood', years: '2004–2006' },
  { rank: 25, title: 'The Leftovers', years: '2014–2017' },
  { rank: 26, title: 'Black Mirror', years: '2011–present' },
  { rank: 27, title: 'Better Call Saul', years: '2015–2022' },
  { rank: 28, title: 'Band of Brothers', years: '2001' },
  { rank: 29, title: 'Key & Peele', years: '2012–2015' },
  { rank: 30, title: 'Severance', years: '2022–present' },
  { rank: 31, title: 'Survivor', years: '2000–present' },
  { rank: 32, title: 'Andor', years: '2022–2025' },
  { rank: 33, title: 'Enlightened', years: '2011–2013' },
  { rank: 34, title: "Schitt's Creek", years: '2015–2020' },
  { rank: 35, title: 'True Detective (Season 1)', years: '2014' },
  { rank: 36, title: 'The Pitt', years: '2025–present' },
  { rank: 37, title: 'Battlestar Galactica', years: '2005–2009' },
  { rank: 38, title: 'Homeland', years: '2011–2020' },
  { rank: 39, title: 'Watchmen', years: '2019' },
  { rank: 40, title: 'Adolescence', years: '2025' },
  { rank: 41, title: 'Louie', years: '2010–2015' },
  { rank: 42, title: 'Hacks', years: '2021–2026' },
  { rank: 43, title: 'Peaky Blinders', years: '2013–2022' },
  { rank: 44, title: 'BoJack Horseman', years: '2014–2020' },
  { rank: 45, title: 'Happy Valley', years: '2014–2023' },
  { rank: 46, title: 'Broad City', years: '2014–2019' },
  { rank: 47, title: 'Twin Peaks: The Return', years: '2017' },
  { rank: 48, title: 'House of Cards', years: '2013–2018' },
  { rank: 49, title: 'Normal People', years: '2020' },
  { rank: 50, title: 'Parks and Recreation', years: '2009–2015' },
  { rank: 51, title: 'The Good Place', years: '2016–2020' },
  { rank: 52, title: 'Downton Abbey', years: '2010–2015' },
  { rank: 53, title: 'Stranger Things', years: '2016–2025' },
  { rank: 54, title: 'The Bureau', years: '2015–2020' },
  { rank: 55, title: 'Insecure', years: '2016–2021' },
  { rank: 56, title: 'Nathan for You', years: '2013–2017' },
  { rank: 57, title: 'I Think You Should Leave', years: '2019–present' },
  { rank: 58, title: "Chappelle's Show", years: '2003–2006' },
  { rank: 59, title: 'PEN15', years: '2019–2021' },
  { rank: 60, title: 'Peep Show', years: '2003–2015' },
  { rank: 61, title: "RuPaul's Drag Race", years: '2009–present' },
  { rank: 62, title: 'Slow Horses', years: '2022–present' },
  { rank: 63, title: 'The Thick of It', years: '2005–2012' },
  { rank: 64, title: 'Anthony Bourdain: Parts Unknown', years: '2013–2018' },
  { rank: 65, title: 'Mare of Easttown', years: '2021' },
  { rank: 66, title: 'The Rehearsal', years: '2022–present' },
  { rank: 67, title: "The Handmaid's Tale", years: '2017–2025' },
  { rank: 68, title: 'Ozark', years: '2017–2022' },
  { rank: 69, title: 'Anthony Bourdain: No Reservations', years: '2005–2012' },
  { rank: 70, title: 'The Shield', years: '2002–2008' },
  { rank: 71, title: 'Beef (Season 1)', years: '2023' },
  { rank: 72, title: 'Squid Game', years: '2021–2025' },
  { rank: 73, title: 'Barry', years: '2018–2023' },
  { rank: 74, title: 'The Bear', years: '2022–2026' },
  { rank: 75, title: 'Ted Lasso', years: '2020–present' },
  { rank: 76, title: 'Somebody Somewhere', years: '2022–2024' },
  { rank: 77, title: 'Modern Family', years: '2009–2020' },
  { rank: 78, title: "It's Always Sunny in Philadelphia", years: '2005–present' },
  { rank: 79, title: 'The Good Wife', years: '2009–2016' },
  { rank: 80, title: 'How To With John Wilson', years: '2020–2023' },
  { rank: 81, title: "The Queen's Gambit", years: '2020' },
  { rank: 82, title: 'Better Things', years: '2016–2022' },
  { rank: 83, title: 'Justified', years: '2010–2015' },
  { rank: 84, title: 'Planet Earth', years: '2006' },
  { rank: 85, title: 'The Great British Baking Show', years: '2010–present' },
  { rank: 86, title: 'Shogun', years: '2024–present' },
  { rank: 87, title: 'Reservation Dogs', years: '2021–2023' },
  { rank: 88, title: 'Dexter', years: '2006–2013' },
  { rank: 89, title: 'Baby Reindeer', years: '2024' },
  { rank: 90, title: 'Eastbound & Down', years: '2009–2013' },
  { rank: 91, title: 'Catastrophe', years: '2015–2019' },
  { rank: 92, title: 'The Night Of', years: '2016' },
  { rank: 93, title: 'Station Eleven', years: '2021–2022' },
  { rank: 94, title: 'The Diplomat', years: '2023–present' },
  { rank: 95, title: 'House', years: '2004–2012' },
  { rank: 96, title: 'Halt and Catch Fire', years: '2014–2017' },
  { rank: 97, title: 'Community', years: '2009–2015' },
  { rank: 98, title: 'The OA', years: '2016–2019' },
  { rank: 99, title: 'Gilmore Girls', years: '2000–2007' },
  { rank: 100, title: 'Scandal', years: '2012–2018' },
];
